const toCompletedInput = (completed) =>
  (completed ?? []).map(({ type, value }) => ({ type, value }));

/**
 * Sparse `SalesReportInput` of one card: the values of `fieldNames` (direct fields of
 * `salesReport`, e.g. `salesHakLocationState`) plus the card states `completed`. Photos have their
 * own mutations (see feature page projekt-protokolle).
 */
export const toSalesCardInput = (salesReport, fieldNames) => ({
  ...Object.fromEntries(
    fieldNames.map((fieldName) => [fieldName, salesReport?.[fieldName] ?? null])
  ),
  completed: toCompletedInput(salesReport?.completed),
});
